import { Phone, Mail, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/components/Nav";

export const Footer = () => (
  <footer className="bg-obsidian text-cream" data-testid="footer-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <img src="/logo.jpeg" alt="Chauffeur Privé DCR" className="h-20 w-20 object-cover rounded-sm mb-6" />
        <p className="text-sm text-neutral-400 leading-relaxed max-w-sm">Chauffeur Privé DCR — Transport privé à bord d'une Toyota C-HR hybride. Disponible 24h/24, 7j/7, sur réservation.</p>
      </div>
      <div className="md:col-span-4">
        <p className="text-xs uppercase tracking-[0.25em] font-mono text-gold mb-6">Contact direct</p>
        <ul className="space-y-4 text-sm">
          <li><a href="tel:+33651026078" data-testid="footer-phone" className="flex items-center gap-3 text-neutral-300 hover:text-gold transition-colors"><Phone size={14} className="text-gold" /> +33 6 51 02 60 78</a></li>
          <li><a href="https://wa.me/33651026078" target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-neutral-300 hover:text-gold transition-colors"><MessageCircle size={14} className="text-gold" /> WhatsApp</a></li>
          <li><a href="mailto:tiheart92@gmail.com" data-testid="footer-email" className="flex items-center gap-3 text-neutral-300 hover:text-gold transition-colors"><Mail size={14} className="text-gold" /> tiheart92@gmail.com</a></li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="text-xs uppercase tracking-[0.25em] font-mono text-gold mb-6">Accès rapide</p>
        <ul className="space-y-4 text-sm">
          <li><button onClick={() => scrollToId("#reservation")} data-testid="footer-booking-link" className="text-neutral-300 hover:text-gold transition-colors">Réserver une course</button></li>
          <li><button onClick={() => scrollToId("#flotte")} data-testid="footer-fleet-link" className="text-neutral-300 hover:text-gold transition-colors">Le véhicule</button></li>
          <li><Link to="/suivi" data-testid="footer-tracking-link" className="text-neutral-300 hover:text-gold transition-colors">Suivi de réservation</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-neutral-800">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-neutral-500 font-mono">
        <span>© 2026 Chauffeur Privé DCR — Exploitant VTC agréé</span>
        <span className="flex items-center gap-6">
          <span>Carte professionnelle VTC · Paris</span>
          <Link to="/demandes" data-testid="footer-driver-link" className="hover:text-gold transition-colors">Espace chauffeur</Link>
        </span>
      </div>
    </div>
  </footer>
);
